// Login.js
import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

const Login = () => {
  const { loginWithRedirect } = useAuth0();
  return (
    <div>
      <button className="top-button" onClick={() => loginWithRedirect()} alt="log in">Log In</button>
    </div>
  );
};

export default Login;
